import { render, staticRenderFns } from "./jaUser.vue?vue&type=template&id=02332032&scoped=true&"
import script from "./jaUser.vue?vue&type=script&lang=js&"
export * from "./jaUser.vue?vue&type=script&lang=js&"
import style0 from "./jaUser.vue?vue&type=style&index=0&id=02332032&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02332032",
  null
  
)

export default component.exports